import React from "react";
import { Hourglass } from "react-loader-spinner";

const Loader = () => {
  return (
    <>
      <style>{css}</style>
      <div className="loader-root">
        {/* Ambient orbs */}
        <div className="loader-orb loader-orb1" />
        <div className="loader-orb loader-orb2" />

        {/* Ripple rings around the loader */}
        <div className="loader-ring loader-ring1" />
        <div className="loader-ring loader-ring2" />
        <div className="loader-ring loader-ring3" />

        {/* Center content */}
        <div className="loader-center">
          {/* Rotating red arc behind hourglass */}
          <div className="loader-arc" />

          <div className="loader-hourglass">
            <Hourglass
              visible={true}
              height="72"
              width="72"
              ariaLabel="hourglass-loading"
              wrapperStyle={{}}
              wrapperClass=""
              colors={['#e81b23', 'rgba(255,255,255,0.9)']}
            />
          </div>

          <p className="loader-text">Loading</p>
          <div className="loader-dots">
            <span className="loader-dot" />
            <span className="loader-dot" />
            <span className="loader-dot" />
          </div>
        </div>
      </div>
    </>
  );
};

export default Loader;

const css = `
  .loader-root {
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(8, 8, 14, 0.92);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  /* Ambient orbs */
  .loader-orb { position: absolute; border-radius: 50%; pointer-events: none; }
  .loader-orb1 {
    top: -10%; left: -10%;
    width: 500px; height: 500px;
    background: radial-gradient(circle, rgba(232,27,35,0.15) 0%, transparent 70%);
    filter: blur(12px);
    animation: loaderOrbFloat1 10s ease-in-out infinite;
  }
  .loader-orb2 {
    bottom: -10%; right: -10%;
    width: 500px; height: 500px;
    background: radial-gradient(circle, rgba(180,10,18,0.12) 0%, transparent 70%);
    filter: blur(16px);
    animation: loaderOrbFloat2 14s ease-in-out infinite;
  }

  /* Ripple rings */
  .loader-ring {
    position: absolute;
    border-radius: 50%;
    border: 1px solid rgba(232,27,35,0.25);
    top: 50%; left: 50%;
    transform: translate(-50%,-50%) scale(0.8);
    pointer-events: none;
  }
  .loader-ring1 { width:160px; height:160px; animation: loaderRipple 2.4s ease-out infinite; }
  .loader-ring2 { width:160px; height:160px; animation: loaderRipple 2.4s ease-out infinite 0.8s; }
  .loader-ring3 { width:160px; height:160px; animation: loaderRipple 2.4s ease-out infinite 1.6s; }

  /* Center */
  .loader-center {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    animation: loaderReveal 0.5s cubic-bezier(0.22,1,0.36,1);
  }

  /* Rotating red arc */
  .loader-arc {
    position: absolute;
    top: 50%; left: 50%;
    width: 110px; height: 110px;
    margin-top: -55px; margin-left: -55px;
    border-radius: 50%;
    border: 2px solid transparent;
    border-top-color: #e81b23;
    border-right-color: rgba(232,27,35,0.3);
    box-shadow: 0 0 16px rgba(232,27,35,0.4);
    animation: loaderSpin 1.2s linear infinite;
    pointer-events: none;
  }

  .loader-hourglass {
    display: flex;
    transform: scale(0.5) translateY(40px);
    align-items: center;
    justify-content: center;
    filter: drop-shadow(0 0 12px rgba(232,27,35,0.5));
  }

  .loader-text {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.22em;
    text-transform: uppercase;
    color: rgba(200,200,215,0.6);
    margin-top: 4px;
  }

  /* Bouncing dots */
  .loader-dots { display: flex; gap: 5px; align-items: center; }
  .loader-dot {
    width: 5px; height: 5px;
    border-radius: 50%;
    background: #e81b23;
    box-shadow: 0 0 6px rgba(232,27,35,0.7);
    animation: loaderDotBounce 1.2s ease-in-out infinite;
  }
  .loader-dot:nth-child(2) { animation-delay: 0.2s; background: rgba(232,27,35,0.6); }
  .loader-dot:nth-child(3) { animation-delay: 0.4s; background: rgba(232,27,35,0.35); }

  /* Keyframes */
  @keyframes loaderReveal {
    from { opacity: 0; transform: scale(0.88); }
    to   { opacity: 1; transform: scale(1); }
  }
  @keyframes loaderRipple {
    0%   { transform: translate(-50%,-50%) scale(0.8); opacity: 0.7; }
    100% { transform: translate(-50%,-50%) scale(2.2); opacity: 0; }
  }
  @keyframes loaderSpin {
    to { transform: rotate(360deg); }
  }
  @keyframes loaderDotBounce {
    0%,80%,100% { transform: translateY(0); opacity: 0.4; }
    40%          { transform: translateY(-6px); opacity: 1; }
  }
  @keyframes loaderOrbFloat1 {
    0%,100% { transform: translate(0,0) scale(1); }
    50%     { transform: translate(40px,-40px) scale(1.1); }
  }
  @keyframes loaderOrbFloat2 {
    0%,100% { transform: translate(0,0) scale(1); }
    50%     { transform: translate(-40px,40px) scale(1.1); }
  }
`;